/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { Checkbox } from '@powdr/components';
import { ButtonText, FormSilverpopRequiredFields, FormTypes } from '@powdr/constants';

export const ScanChallenge2526Form = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText = null,
}) => {
  const captchaRef = useRef();

  return (
    <form
      id="scan-challenge-25-26-V1"
      onSubmit={(e) => processForm(e, null, null, captchaRef, FormTypes.SILVERPOP)}
    >
      <input name="CONTACT_LIST_ID" type="hidden" value="17207763" />
      <input id="SCAN_CHALLENGE_OPT_IN" name="Copper 2526 Scan Challenge Opt In" type="hidden" value="Yes" />

      <label className="input-label">
        Email *
        <input
          className="form-control"
          type="text"
          name={FormSilverpopRequiredFields.EMAIL}
          id="control_EMAIL"
          label="Email Address"
          placeholder="Email Address"
          required
        />
      </label>

      <label className="input-label">
        First Name *
        <input
          name="First Name"
          id="container_COLUMN3"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Last Name *
        <input
          name="Last Name"
          id="container_COLUMN4"
          className="form-control"
          type="text"
          required
        />
      </label>

      <Checkbox
        type="checkbox"
        className="checkbox"
        value="Yes"
        name="control_COLUMN101"
        label="Yes! Sign me up to receive all 25/26 Copper Scan Challenge marketing emails.*"
        required
      />

      <br />

      <Checkbox
        type="checkbox"
        className="checkbox"
        name="age-email-confirmation"
        value="Yes"
        label="Yes! I am 18 years old or older and have provided a valid email address.*"
        required
      />

      <br />

      <Checkbox
        type="checkbox"
        className="checkbox"
        name="accept-scan-challenge-terms-conditions"
        value="Yes"
        label="I accept the Official Rules of the 25/26 Scan Challenge.*"
        required
      />

      <br />

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={() => handleCaptchaExpiry()}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>{buttonText || ButtonText.SUBMIT}</button>
    </form>
  );
};

ScanChallenge2526Form.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
